<template>
  <q-page class="ub-page">
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-lg">
        <div class="text-h3">Observability Dashboards</div>
      </div>
    </div>
    <div class="row items-center">
      <div class="col-md-10 offset-md-1 q-ma-md">
        <q-banner dense class="bg-purple-8 text-white">
          <template v-slot:avatar>
            <q-icon name="mdi-information-outline" />
          </template>
          Work in progress ...
        </q-banner>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'Observability',
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {}
};
</script>
